import {UI} from "../../../../stem-core/src/ui/UIBase";
import {styleRule, StyleSheet} from "../../../../stem-core/src/ui/Style";

import {
    PayWithAddedCardComponent,
    PayWithAddedCardComponentStyle
} from "../../pages/panels/payment-method/components/PayWithAddedCardComponent";
import {CardForm, CardInputStyle, NameInput, NameInputStyle} from "../../pages/panels/donation/components/CardForm";
import {registerStyle} from "../../../../stem-core/src/ui/style/Theme";
import {styleRuleInherit} from "../../../../stem-core/src/decorators/Style";
import {CardInput} from "../../pages/panels/donation/components/CardForm";
import {isSmallScreen} from "../../../UtilsLib";
import {Messages} from "../../../Messages";
import {MerchantButton} from "../../../common/MerchantButton";
import {PoweredByBlink} from "../../PoweredByBlink";
import {LoadingSpinner} from "../../../ui/LoadingSpinner";
import {donateMobileState} from "../../inline-donation/DonateMobileState";
import {DONATE_PAGE_URLS} from "../../PanelConstants";
import {StepDescription} from "../StepDescription";
import {authService} from "../../../../client/connection/Services";
import {paymentMethodController} from "../../inline-donation/PaymentMethodController";


class DonateHomeNameInputStyle extends NameInputStyle {
    @styleRuleInherit
    inputContainer = this.themeProps.DONATE_PAGE_INPUT_CONTAINER;
}

@registerStyle(DonateHomeNameInputStyle)
class DonateHomeNameInput extends NameInput {}

class DonateHomeCardInputStyle extends CardInputStyle {
    @styleRuleInherit
    inputContainer = {
        ...this.themeProps.DONATE_PAGE_INPUT_CONTAINER,
        padding: isSmallScreen() ? "0.25rem 5px 0.25rem 12px" : "",
        border: "1px solid",
        height: 40,
        transition: "box-shadow 0.2s ease",
    };

    @styleRuleInherit
    focused = {
        borderColor: this.themeProps.DONATE_PAGE_INPUT_FOCUSED_BORDER_COLOR,
        boxShadow: this.themeProps.DONATE_PAGE_INPUT_FOCUSED_SHADOW,
    }
}

@registerStyle(DonateHomeCardInputStyle)
class DonateHomeCardInput extends CardInput {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            stripeStyle: {
                base: {
                    fontSize: this.styleSheet.themeProps.MERCHANT_FONT_SIZE_LARGE,
                    color: this.styleSheet.themeProps.DONATE_PAGE_CARD_INPUT_COLOR,
                    iconColor: this.styleSheet.themeProps.DONATE_PAGE_INPUT_FOCUSED_BORDER_COLOR,
                    fontFamily: this.styleSheet.themeProps.DONATE_PAGE_FONT_FAMILY,
                    "::placeholder": {
                        color: this.styleSheet.themeProps.BLINK_INPUT_PLACEHOLDER,
                        fontWeight: this.styleSheet.themeProps.MERCHANT_FONT_WEIGHT_REGULAR,
                    },
                },
            },
        };
    }
}

class DonateHomeCardForm extends CardForm {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            NameInputClass: DonateHomeNameInput,
            CardInputClass: DonateHomeCardInput,
        };
    }
}

class DonateHomePayWithAddedCardComponentStyle extends PayWithAddedCardComponentStyle {
    @styleRuleInherit
    title = {
        fontWeight: this.themeProps.MERCHANT_FONT_WEIGHT_BOLD,
        fontSize: 24,
        marginBottom: 20,
    };
}

@registerStyle(DonateHomePayWithAddedCardComponentStyle)
export class DonateHomePayWithAddedCardComponent extends PayWithAddedCardComponent {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            CardFormClass: DonateHomeCardForm,
            checkboxLabel: Messages.donateSaveCardDetailsCheckbox,
        };
    }
}

class PayWithAddedCardPanelStyle extends StyleSheet {
    @styleRule
    button = {
        ...this.themeProps.DONATE_PAGE_BUTTON,
        margin: "20px 0 8px",
    };
}

@registerStyle(PayWithAddedCardPanelStyle)
export class PayWithAddedCardPanel extends UI.Element {
    render() {
        return [
            <StepDescription backFunction={() => this.options.changeURL(authService.isAuthenticated() ?
                                    DONATE_PAGE_URLS.donate : DONATE_PAGE_URLS.auth, true)}
                             currentStep={StepDescription.stepCount} stepDescription={Messages.paymentStep}/>,
            <DonateHomePayWithAddedCardComponent ref="cardComponent" onChange={() => this.redraw()}/>,
            <MerchantButton className={this.styleSheet.button} disabled={!this.cardComponent?.isValid()}
                            onClick={() => this.donate()}>
                {Messages.finalizePayment}
            </MerchantButton>,
            <PoweredByBlink/>
        ];
    }

    donate() {
        LoadingSpinner.show();

        this.cardComponent.getPaymentMethodId(paymentMethodController.getScope(), preferredPaymentMethodId => {
            let payload = {
                amount: donateMobileState.getTotalAmount(),
                frequency: donateMobileState.getFrequency(),
                coversFees: donateMobileState.payDonationFeeCheckboxChecked,
            };
            if (preferredPaymentMethodId) {
                payload.preferredPaymentMethodId = preferredPaymentMethodId
            }
            donateMobileState.setPayload(payload);
            donateMobileState.donate(() => this.options.changeURL(DONATE_PAGE_URLS.thankYou),
                () => this.options.changeURL(DONATE_PAGE_URLS.paymentFailed, true));
        }, () => {
            // Error rendering is done in the card component.
            LoadingSpinner.hide();
        });
    }

    onMount() {
        super.onMount();
        authService.onAuthenticationChange(() => {
            if (this.isInDocument() && !authService.isAuthenticated()) {
                this.options.changeURL(DONATE_PAGE_URLS.donate, true);
            }
        });
    }
}
